;(function(window, $) {
    window.ns = window.ns || {};

    window.openShareDialog= function (url) {
        setTimeout( function () {
            window.open(url, 'share_dialog', 'width=700,height=500,left=200,top=100,location=no,directories=no,status=no,toolbar=no,menubar=no');
        },100);
        return false;
    };


    window.ns['blog'] = {
        init: function() {
            var waitForFinalEvent = (function () {
                var timers = {};
                return function (callback, ms, uniqueId) {
                    if (!uniqueId) {
                        uniqueId = "Don't call this twice without a uniqueId";
                    }
                    if (timers[uniqueId]) {
                        clearTimeout (timers[uniqueId]);
                    }
                    timers[uniqueId] = setTimeout(callback, ms);
                };
            })();

            var sidebarEl = $('[data-sticky="popular"]');
            if(!sidebarEl.length) return;
            sidebarEl.width(sidebarEl.width());

            window.addEventListener('resize', function(){
                sidebarEl.css('width', 'auto');
                sidebarEl.removeClass('stuck');

                waitForFinalEvent(function(){
                    sidebarEl.width(sidebarEl.width());
                });
            });

            var sticky = new Waypoint.Sticky({
                element: sidebarEl[0]
            });

            var li = $('.news-listing-item');
            $.each(li, function(index, val) {
                /* iterate through array or object */
                var inview = new Waypoint.Inview({
                    element: val,
                    enter: function(direction) {
                        // console.log('Enter triggered with direction ' + direction)
                    },
                    entered: function(direction) {
                        // console.log('Entered triggered with direction ' + direction);
                        $(val).find('.news-listing-item_puplish-date').addClass('isVisible');
                    },
                    exit: function(direction) {
                        // console.log('Exit triggered with direction ' + direction)
                        $(val).find('.news-listing-item_puplish-date').removeClass('isVisible');
                    },
                    exited: function(direction) {
                        // console.log('Exited triggered with direction ' + direction)

                    }
                });
            });
        }
    };
})(window, jQuery);
